/* eslint-disable @typescript-eslint/no-explicit-any */

import { isArray } from './is-array';
import { isObject } from './is-object';
import { notUndefined } from './not-undefined';

export function camelizeString(value: string) {
  return value
    .split('_')
    .map((word, index) => {
      if (word === '') {
        return undefined;
      }

      if (index === 0) {
        return word;
      }

      return word[0].toUpperCase() + word.substring(1);
    })
    .filter(notUndefined)
    .join('');
}

export function camelize(obj: any): any {
  if (isArray(obj)) {
    return obj.map(camelize);
  }

  if (!isObject(obj)) {
    return obj;
  }

  Object.entries(obj).forEach(([key, value]) => {
    const camelKey = camelizeString(key);

    delete obj[key];
    obj[camelKey] = camelize(value);
  });

  return obj;
}
